import api from './api';

export async function getEspecialidades() {
    const response = await api.get(`/Especialidade`);
    return response.data;
}
